var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinLogo = function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedinLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.038.572H7.703A7.65 7.65 0 0 0 .055 8.22v17.336a7.65 7.65 0 0 0 7.648 7.648h17.335a7.65 7.65 0 0 0 7.648-7.648V8.22A7.65 7.65 0 0 0 25.038.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M25.038.572H7.703A7.65 7.65 0 0 0 .055 8.22v17.336a7.65 7.65 0 0 0 7.648 7.648h17.335a7.65 7.65 0 0 0 7.648-7.648V8.22A7.65 7.65 0 0 0 25.038.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 28.32h3.73a.51.51 0 0 0 .51-.51l.003-7.883c0-4.12-.888-7.287-5.703-7.287a5 5 0 0 0-4.488 2.451.04.04 0 0 1-.067.004.04.04 0 0 1-.009-.024v-1.54a.51.51 0 0 0-.51-.51h-3.54a.51.51 0 0 0-.51.51v14.278a.51.51 0 0 0 .51.51h3.73a.51.51 0 0 0 .51-.51v-7.058c0-1.996.379-3.928 2.853-3.928 2.44 0 2.47 2.283 2.47 4.057v6.93a.51.51 0 0 0 .51.51M4.898 8.173a2.77 2.77 0 0 0 2.758 2.757 2.77 2.77 0 0 0 2.756-2.758 2.77 2.77 0 0 0-2.757-2.756 2.77 2.77 0 0 0-2.757 2.757m.887 20.147h3.736a.51.51 0 0 0 .51-.51V13.53a.51.51 0 0 0-.51-.51H5.785a.51.51 0 0 0-.51.51v14.28a.51.51 0 0 0 .51.51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedinLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.055.571h32.632v32.632H.055z"
  })))));
};
export default SvgLinkedinLogo;